/* Adapt — generic floating pill nav, reused pattern from the PDP's scroll-pin pill
   (see assets/adapt-scrollpin-gallery.js setupPillNav), but generalized: reads its
   section map straight from whatever a[data-nav-item] links exist inside the static
   pill, instead of hardcoding testimonials/benefits/faq. Any page can drop in a
   [data-pill-nav] element with 2+ anchor links and this wires it up automatically.

   Shares the exact same CSS classes as the PDP pill (.ad-scrollpin-pillNav,
   .ad-scrollpin-floatingWrap, .ad-scrollpin-navSection, is-active/is-visible/
   is-suppressed) from assets/adapt-scrollpin-gallery.css, so it looks and animates
   identically without duplicating any styles.

   MANUAL SCROLL ON CLICK (2026-08-12): links used to rely purely on native browser
   anchor-jump (real <a href="#id">). On mobile this required two taps before it
   scrolled all the way to the target — the site's page-transition/soft-navigation
   script intercepts the first click as a navigation attempt rather than letting the
   browser's native same-page hash-jump run, so the first tap did nothing (or only a
   partial jump) and only the second tap actually landed. Now every pill link gets
   its own click handler that prevents default and calls scrollIntoView directly —
   bypasses whatever intercepts the native anchor behavior, works in one tap. Browser
   still honors scroll-margin-top on the target for correct offset under the sticky
   header/pill. */
(function () {
  function setupGenericPillNav(staticNav) {
    var floatingWrap = document.createElement('div');
    floatingWrap.className = 'ad-scrollpin-floatingWrap';
    floatingWrap.appendChild(staticNav.cloneNode(true));
    document.body.appendChild(floatingWrap);
    var floatingNav = floatingWrap.querySelector('[data-pill-nav]');

    var staticLinks = Array.prototype.slice.call(staticNav.querySelectorAll('a[data-nav-item]'));
    var floatingLinks = Array.prototype.slice.call(floatingNav.querySelectorAll('a[data-nav-item]'));

    function setActive(key) {
      staticLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav-item') === key); });
      floatingLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav-item') === key); });
    }

    function scrollToTarget(href) {
      var targetId = href.replace('#', '');
      var target = document.getElementById(targetId);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    staticLinks.concat(floatingLinks).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToTarget(a.getAttribute('href'));
      });
    });

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var fullyPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          floatingWrap.classList.toggle('is-visible', fullyPassed);
        });
      }, { threshold: 0 });
      visibilityObserver.observe(staticNav);
    }

    var sections = {};
    staticLinks.forEach(function (a) {
      var key = a.getAttribute('data-nav-item');
      var targetId = a.getAttribute('href').replace('#', '');
      var target = document.getElementById(targetId);
      if (target) sections[key] = target;
    });

    if ('IntersectionObserver' in window) {
      var activeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var matchKey = Object.keys(sections).filter(function (k) { return sections[k] === entry.target; })[0];
            if (matchKey) setActive(matchKey);
          }
        });
      }, { rootMargin: '-110px 0px -70% 0px', threshold: 0 });

      Object.keys(sections).forEach(function (key) { activeObserver.observe(sections[key]); });
    }

    if (staticLinks[0]) setActive(staticLinks[0].getAttribute('data-nav-item'));

    /* suppress floating twin while any overlay (menu/cart drawer, search modal) is open —
       same logic as the PDP pill, self-contained here so this file has no dependency on
       adapt-scrollpin-gallery.js loading at all. */
    function isAnyOverlayOpen() {
      return !!document.querySelector(
        'details[open][id*="menu-drawer" i], ' +
        'details[open][id*="drawer" i], ' +
        'theme-drawer[open], ' +
        'dialog[open], ' +
        '[data-search-modal][open], ' +
        '.search-modal.is-open, ' +
        '.menu-drawer.is-open'
      );
    }
    function refreshSuppression() {
      floatingWrap.classList.toggle('is-suppressed', isAnyOverlayOpen());
    }
    document.addEventListener('toggle', refreshSuppression, true);
    document.addEventListener('click', function () { setTimeout(refreshSuppression, 50); }, true);
    if ('MutationObserver' in window) {
      new MutationObserver(refreshSuppression).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['open', 'class'],
        subtree: true
      });
    }
    refreshSuppression();
  }

  function init() {
    document.querySelectorAll('[data-pill-nav]').forEach(function (nav) {
      // skip if this nav is itself inside a floating wrap (i.e. already a clone)
      if (nav.closest('.ad-scrollpin-floatingWrap')) return;
      try { setupGenericPillNav(nav); } catch (e) { console.error('adapt-generic-pillnav: setup failed', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
